import script from "./icon-google-play.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-google-play.vue?vue&type=script&lang=ts&setup=true"

import "./icon-google-play.vue?vue&type=style&index=0&id=af65e0c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af65e0c2"]])

export default __exports__